import { render } from "./OffcanvasManageProducts.vue?vue&type=template&id=5f8d2dc6"
import script from "./OffcanvasManageProducts.vue?vue&type=script&lang=js"
export * from "./OffcanvasManageProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__